import { type DateInput, format } from '@formkit/tempo';

export const formatToApiDate = (inputDate: DateInput | null | undefined): string | undefined => {
    return inputDate ? format({
        date: inputDate,
        format: 'YYYY-MM-DD'
    }) : undefined;
};
